/**
 * Default fall back Error page
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, themes, activateTheme } from '../../canvasComponents/index';
// Intl
import { injectIntl, FormattedMessage } from 'react-intl';
// messages
import messages from './messages';
import '../../css/domain/Error/Error.scss';

function Error() {
  const navigate = useNavigate();

  const handleRoute = () => {
    navigate('/dashboard');
  };

  useEffect(() => {
    activateTheme(themes.sonnet);
  }, []);

  return (
    <div className="error-page">
      <div className="error-title">
        <FormattedMessage {...messages.someWentWrong} />
        <a className="error-title phoneNumber" style={{ textDecoration: 'none' }} href="tel: 1-844-766-6384"><FormattedMessage {...messages.phoneNumber} /></a>
      </div>
      <Button primary onClick={handleRoute} className="backToDashBtn">
        <FormattedMessage {...messages.backToDashboard} />
      </Button>
    </div>
  );
}

export default injectIntl(Error);
